export var FLUENT_CDN_BASE_URL = 'https://res.cdn.office.net/files/fabric-cdn-prod_20250411.001';
//# sourceMappingURL=cdn.js.map